import keyMirror from 'keymirror';
import { createReduxConstants } from '@bibliocommons/utils-redux';

export const LIST_CATEGORIES = keyMirror({
  STAFF: null,
  COMMUNITY: null
});

export default createReduxConstants('LISTS', {
  GET_LISTS_REQUEST: null,
  GET_LISTS_SUCCESS: null,
  GET_LISTS_FAILURE: null
});
